import React from 'react';
import { NavigateFunction } from 'react-router-dom';

export function hocMobileClose(callback: NavigateFunction) {
  const isMobileView = localStorage.getItem('isMobile') === 'true';
  if (isMobileView) {
    window.location.href = 'about:blank';
  } else {
    callback(-1);
  }
}
